import axios from "axios";

export function srtToVtt(srt) {
    // Strip BOM and normalize newlines
    const text = srt
        .replace(/^\uFEFF/, "")
        .replace(/\r\n/g, "\n")
        .replace(/\r/g, "\n");

    const blocks = text.trim().split(/\n{2,}/);
    const vttLines = ["WEBVTT", ""];

    for (const block of blocks) {
        const lines = block.split("\n").filter(Boolean);

        // Skip numeric index if present
        let i = 0;
        if (lines[0] && /^\d+$/.test(lines[0])) i = 1;

        if (!lines[i]) continue;

        // Convert SRT time commas to VTT periods
        const timeLine = lines[i].replace(
            /(\d{2}:\d{2}:\d{2}),(\d{3})/g,
            "$1.$2"
        );

        // Remaining lines are cue text
        const cueLines = lines.slice(i + 1);

        vttLines.push(timeLine);
        vttLines.push(...cueLines);
        vttLines.push("");
    }

    return vttLines.join("\n");
}

export async function getVttDataUrl(srtUrl) {
    try {
        const { data } = await axios.get(srtUrl, {
            responseType: "text",
            withCredentials: false,
            transformResponse: (r) => r,
            headers: { Accept: "text/plain, */*;q=0.1" },
            timeout: 15000,
            maxContentLength: 20 * 1024 * 1024,
        });

        const vtt = srtToVtt(data);
        const base64 = Buffer.from(vtt, "utf8").toString("base64");
        return `data:text/vtt;charset=utf-8;base64,${base64}`;
    } catch (error) {
        console.error(error);
        return null;
    }
}
